import React from 'react';
import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.general?.grey100 || '#999',
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(14),
  marginRight: theme.spacing(1),
  minHeight: 42,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  '&:focus': {
    opacity: 1,
  },
}));

const TabComponent = (props) => {
  return <StyledTab disableRipple {...props} />;
};

export default TabComponent;
